import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { automationApi, type WorkflowTemplate } from '../../api/automation';

export function TemplateLibraryPage() {
  const [templates, setTemplates] = useState<WorkflowTemplate[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void automationApi.listTemplates().then((r) => setTemplates(r.templates ?? [])).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold">Template Library</h1>
          <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">Reusable workflow templates for common business processes.</p>
        </div>
        <Link to="/automation" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Automation Hub</Link>
      </div>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2">
        {templates.map((t) => (
          <div key={t.id} className="rounded-xl border p-4 dark:border-slate-700">
            <div className="flex items-start justify-between">
              <div>
                <p className="font-medium">{t.name}</p>
                <p className="mt-1 text-xs text-slate-500">{t.category}</p>
              </div>
              <span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs dark:bg-slate-800">{t.nodes?.length ?? 0} nodes</span>
            </div>
            {t.description && <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">{t.description}</p>}
            {t.tags && t.tags.length > 0 && (
              <div className="mt-3 flex flex-wrap gap-1">
                {t.tags.map((tag) => (
                  <span key={tag} className="rounded bg-brand-50 px-2 py-0.5 text-xs text-brand-700 dark:bg-brand-950 dark:text-brand-300">{tag}</span>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
